import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import useGetAuthed from "../../../helpers/hooks/useGetAuthed";
import moment from "moment";

function ProposedHistoryModal2({ modal, toggleModal, loanId }) {
  // State
  const [data, setData] = useState([]);

  // Hooks
  const [revisionData, revisionError, revisionLoading, revisionCall] =
    useGetAuthed(`get_all_proposed_changes/?loan_id=${loanId}`, true, "loan");

  console.log(revisionData);

  useEffect(() => {
    if (revisionData?.length > 0) {
      setData(revisionData.reverse());
    }
  }, [revisionData]);

  return (
    <Modal
      className="modal-dialog-centered"
      isOpen={modal}
      toggle={toggleModal}
      style={{ maxWidth: "800px" }}
    >
      <ModalHeader toggle={toggleModal}>Revision History</ModalHeader>
      <ModalBody>
        {revisionLoading ? (
          <Card>
            <CardBody className="text-center">
              <Spinner className="mr-2" color="primary"></Spinner>
            </CardBody>
          </Card>
        ) : (
          <div>
            {data.map((x) => {
              return (
                <MDBCard key={x.id}>
                  <MDBCardHeader
                    style={{ height: "100px", backgroundColor: "#fff" }}
                  >
                    <MDBRow>
                      <MDBCol>
                        <MDBTable>
                          <MDBTableHead style={{ padding: "35px" }}>
                            <tr style={{ padding: "35px" }}>
                              <th
                                style={{
                                  width: "33%",
                                  borderRight: "1px solid #ddd",
                                  borderBottom: "none",
                                  borderTop: "none",
                                }}
                              >
                                <h6 style={{ marginLeft: "38px" }}>Admin</h6>
                                <div style={{ marginLeft: "25px" }}>
                                  Admin Name
                                </div>
                              </th>
                              <th
                                style={{
                                  width: "33%",
                                  borderRight: "1px solid #ddd",
                                  borderBottom: "none",
                                  borderTop: "none",
                                }}
                              >
                                <h6 className="d-flex justify-content-center">
                                  Status
                                </h6>
                                <Badge
                                  color={
                                    x["is_approved"]
                                      ? "success"
                                      : x["is_approved"] === false
                                      ? "danger"
                                      : "warning"
                                  }
                                  className="font-size-15 d-flex justify-content-center"
                                  style={{
                                    height: "100%",
                                    maxWidth: "70px",
                                    marginLeft: "80px",
                                  }}
                                >
                                  {x["is_approved"]
                                    ? "Approved"
                                    : x["is_approved"] === false
                                    ? "Rejected"
                                    : "Pending"}
                                </Badge>
                              </th>
                              <th
                                style={{
                                  width: "33%",
                                  borderBottom: "none",
                                  borderTop: "none",
                                }}
                              >
                                <h6 className="d-flex justify-content-center">
                                  Date
                                </h6>

                                <div style={{ marginLeft: "48px" }}>
                                  {moment(x["createdAt"]).format(
                                    "DD-MM-YYYY  \u00a0 \u00a0  HH:mm"
                                  )}
                                </div>
                              </th>
                            </tr>
                          </MDBTableHead>
                        </MDBTable>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        overflowX: "auto"
                      }}
                    >
                      <table >
                        <thead
                          style={{
                            height: "60px",
                            width: "100%",
                            backgroundColor: "rgb(246,251,253)",
                          }}
                        >
                          <tr>
                            <th
                              class="rounded-th first-th"
                              style={{
                                fontSize: "1rem",
                                padding: "0 15px",
                              }}
                            >
                              Items
                            </th>
                            <th
                              style={{
                                fontSize: "1rem",
                              }}
                            >
                              Requested By Farmer
                            </th>
                            <th
                              class="rounded-th last-th"
                              style={{
                                fontSize: "1rem",
                              }}
                            >
                              <div style={{ marginRight: "15px" }}>
                                Proposed By Beythak
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {Object.keys(x["proposed_changes"]).map((y) => {
                            if (
                              typeof x["proposed_changes"][y][
                                "requestedValue"
                              ] === "string"
                            ) {
                              return (
                                <tr key={y} style={{ height: "60px" }}>
                                  <td
                                    style={{ width: "40%", padding: "0 12px" }}
                                  >
                                    {y
                                      .split("_")
                                      .map(
                                        (w) =>
                                          w.charAt(0).toUpperCase() +
                                          w.substring(1)
                                      )
                                      .join(" ")}
                                  </td>

                                  <td
                                    style={{ width: "40%", padding: "0 12px" }}
                                  >
                                    {x["proposed_changes"][y]["requestedValue"]}
                                  </td>

                                  <td
                                    style={{ width: "50%", padding: "0 12px" }}
                                  >
                                    {x["proposed_changes"][y]["proposedValue"]}
                                  </td>
                                </tr>
                              );
                            } else if (
                              typeof x["proposed_changes"][y][
                                "requestedValue"
                              ] === "object"
                            ) {
                              return (
                                <tr style={{ height: "60px" }}>
                                  <td
                                    style={{ width: "45%", padding: "0 12px" }}
                                  >
                                    {y
                                      .split("_")
                                      .map(
                                        (w) =>
                                          w.charAt(0).toUpperCase() +
                                          w.substring(1)
                                      )
                                      .join(" ")}
                                  </td>
                                  <td
                                    style={{ width: "50%", padding: "0 12px" }}
                                  >
                                    {
                                      x["proposed_changes"][y][
                                        "requestedValue"
                                      ]["name"]
                                    }
                                  </td>
                                  <td
                                    style={{ width: "40%", padding: "0 12px" }}
                                  >
                                    {
                                      x["proposed_changes"][y]["proposedValue"][
                                        "name"
                                      ]
                                    }
                                  </td>
                                </tr>
                              );
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              );
            })}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

export default ProposedHistoryModal2;
